export const urlRegex = /^[A-Za-z0-9\\-]+$/;
